import { useIntl } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import ActionIcon from '@components/UI/ActionIcon'
import { ICampaignContextProps } from '@context/Campaign/Provider'
import { withCampaign } from '@hocs'
import { IApplicationState } from '@store'
import { selectIsShortlisting, unshortlistSubmissionRequest } from '@store/submissions'
import Theme from '@theme'
import { getSubmissionFilter, getSubmissionSortBy } from '@utils'

interface IActionBarIconUnshortlistProps {
  submissionId: number
  refreshSubmissionsOnAction?: boolean
}

interface IInternalProps extends IActionBarIconUnshortlistProps, ICampaignContextProps {}

export const ActionBarIconUnshortlist = ({
  submissionId,
  campaign,
  refreshSubmissionsOnAction = true,
}: IInternalProps) => {
  const intl = useIntl()
  const history = useHistory()
  const dispatch = useDispatch()

  const isShortlisting = useSelector((state: IApplicationState) =>
    selectIsShortlisting(state, submissionId),
  )

  const filter = getSubmissionFilter(history.location)
  const sortBy = getSubmissionSortBy(history.location)

  const onUnshortlistSubmission = () => {
    dispatch(
      unshortlistSubmissionRequest(campaign.id, submissionId, {
        filter,
        sortBy,
        refreshSubmissions: refreshSubmissionsOnAction,
      }),
    )
  }

  return (
    <ActionIcon
      glyph="heart-solid"
      color={Theme.primaryColor}
      size={1.5}
      onClick={onUnshortlistSubmission}
      tooltip={intl.formatMessage({
        id: 'submission.card.action.removefromshortlist',
      })}
      elementName="unshortlist"
      disabled={isShortlisting}
    />
  )
}

export default withCampaign(ActionBarIconUnshortlist)
